module.exports = __webpack_public_path__ + "static/media/google-maps.bd0db5db.svg";